import * as THREE from 'three'

/** 一畳の畳デッキ（VR時にリグ足元へ常時表示＝ベクション対策の固定リファレンス） */
export class TatamiDeck {
  readonly root = new THREE.Group()

  constructor() {
    const tex = TatamiDeck.makeTatamiTexture()
    const tatami = new THREE.Mesh(
      new THREE.BoxGeometry(0.91, 0.06, 1.82),
      [
        new THREE.MeshStandardMaterial({ color: 0x5a4a2e }),
        new THREE.MeshStandardMaterial({ color: 0x5a4a2e }),
        new THREE.MeshStandardMaterial({ map: tex, roughness: 0.9 }),
        new THREE.MeshStandardMaterial({ color: 0x3a3020 }),
        new THREE.MeshStandardMaterial({ color: 0x5a4a2e }),
        new THREE.MeshStandardMaterial({ color: 0x5a4a2e }),
      ],
    )
    tatami.position.y = -0.03
    this.root.add(tatami)

    const heriMat = new THREE.MeshStandardMaterial({ color: 0x1e2a24, roughness: 0.7 })
    for (const sx of [-1, 1]) {
      const heri = new THREE.Mesh(new THREE.BoxGeometry(0.07, 0.062, 1.82), heriMat)
      heri.position.set(sx * 0.42, -0.028, 0)
      this.root.add(heri)
    }

    const wood = new THREE.MeshStandardMaterial({ color: 0x6b4f2a, roughness: 0.8 })
    for (const [x, z] of [[-0.44, -0.9], [0.44, -0.9], [-0.44, 0.9], [0.44, 0.9]] as const) {
      const post = new THREE.Mesh(new THREE.CylinderGeometry(0.02, 0.025, 0.72, 8), wood)
      post.position.set(x, 0.36, z)
      this.root.add(post)
    }
    const rails: Array<[[number, number, number], [number, number, number]]> = [
      [[0.92, 0.035, 0.035], [0, 0.72, -0.9]],
      [[0.92, 0.035, 0.035], [0, 0.72, 0.9]],
      [[0.035, 0.035, 1.84], [-0.44, 0.72, 0]],
      [[0.035, 0.035, 1.84], [0.44, 0.72, 0]],
    ]
    for (const [size, pos] of rails) {
      const rail = new THREE.Mesh(new THREE.BoxGeometry(...size), wood)
      rail.position.set(...pos)
      this.root.add(rail)
    }
    this.root.visible = false
  }

  setVisible(v: boolean): void {
    this.root.visible = v
  }

  private static makeTatamiTexture(): THREE.CanvasTexture {
    const c = document.createElement('canvas')
    c.width = 256
    c.height = 512
    const ctx = c.getContext('2d')!
    ctx.fillStyle = '#a8a06a'
    ctx.fillRect(0, 0, 256, 512)
    for (let x = 0; x < 256; x += 4) {
      ctx.fillStyle = x % 8 === 0 ? 'rgba(120,110,60,0.5)' : 'rgba(190,182,130,0.35)'
      ctx.fillRect(x, 0, 2, 512)
    }
    for (let y = 0; y < 512; y += 16) {
      ctx.fillStyle = 'rgba(90,85,50,0.18)'
      ctx.fillRect(0, y, 256, 1)
    }
    const tex = new THREE.CanvasTexture(c)
    tex.colorSpace = THREE.SRGBColorSpace
    return tex
  }
}
